import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output,ElementRef} from '@angular/core';
import {CommonService} from '../../common.service';
declare var $ :any;

@Component({
  selector: 'app-case-practice-stage-start',
  templateUrl: './case-practice-stage-start.component.html',
  styleUrls: ['./case-practice-stage-start.component.css']
})
export class CasePracticeStageStartComponent implements OnInit , AfterViewInit {
  @Output() onFinish = new EventEmitter<any>();
  @Input() step:number; // 步骤
  @Input() simulationName: string;// 情景模拟名称
  @Input() stageDocument:any;//静态阶段文案

  tips: string; //内容
  tipsContent: any;//转换成html的内容
  title: string;  //标题
  stageImageSrc: any//阶段图解
  expression: boolean = false; //是否关闭判断
  animateEndingElement: any; //判断动画结束的元素
  endType: number=0;//判断动画结束标识 0未执行 1执行
  stageStartType: number; //阶段类型：0没有图解 1有图解
  assetsRoute: string = "../../../assets";
  constructor(private commonService: CommonService,private el:ElementRef) {}


  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.setStageStartType(this.simulationName);
    this.setStageStartDocWithStep(this.step);
    // console.log(window.screen.width+';'+window.screen.height);
  }

  ngAfterViewInit(){
    this.commonService.initPage({
      'backgroundColor': 'transparent'
    });

    this.setEnableClick('.letterMiddle',this.endType);
  }

  // 设置阶段类型(P.S.目前只有2个情景模拟暂时写死)
  setStageStartType(simulationName){
    if(simulationName == 'performance'){
      this.stageStartType = 1;
    }else{
      this.stageStartType = 0;
    }
  }


  //判断动画结束事件
  setEnableClick(dom,type){
      this.expression = false;
      this.animateEndingElement = this.el.nativeElement.querySelector(dom);
      this.animateEndingElement.addEventListener('animationend',()=>{
        if(type==0){
          this.expression = true;
          console.log(type+':animate is ending');
        }
        if(type==1){
          this.onFinish.emit(true);
          this.expression = false;
          console.log(type+':animate is ending');
        }
      })
  }


  // 关闭动画
  closeAnimation(){
    if(this.expression){
        this.endType = 1;
        $('.top-block').addClass('topImgClose');
        $('.bottom-block').addClass('bottomImgClose');
        this.setEnableClick('.bottomImgClose',this.endType);
    }else{
      return false;
    }
  }


  // 根据step设置内容
  setStageStartDocWithStep(step){
      this.title =this.stageDocument['step'+step].title;
      this.tips = this.stageDocument['step'+step].stageContent;
      this.tipsContent = this.setTipsBottomLine(this.tips);
      this.stageImageSrc = this.stageDocument['step'+step].stageImage;
  }

  //设置文字下划线
  setTipsBottomLine(tips){
    if(tips){
      let html = '<p>';
      // console.log(tips.length);
      for(let i = 0 ,len = tips.length; i<len;i++){
        html+=tips[i];
        if(i>0&&i%16==0&&i<tips.length-1){
          html+='</p><p>';
        }
        if(i==tips.length-1){
          html+='</p>';
        }
      }
      return html;
    }else{
      return 'tips is undefined!';
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/case-practice-animation/case-practice-stage-start/case-practice-stage-start.component.ts